<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;">{{ title }}</div>
        </div>

        <div v-if="hasValidAddress" class="mt-1 mb-3">
            <iframe
                width="100%"
                height="500"
                frameborder="0" style="border:0"
                :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyBkpuL88K4NKBGYsERvQDW1JFmGJ6txLVM&q=' + this.content.data.address"
                allowfullscreen
            >
            </iframe>
        </div>
    </div>
</template>

<script>
import Constants from '../../constants';

export default {
    props: ['question', 'providerId', 'context', 'answer'],
    data() {
        const content = this.question.content;
        return {
            id: this.question.id,
            content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            showInvalid: false,
        };
    },
    computed: {
        title: function() {
            return this.content.meta.title || '';
        },
        hasAnswer() {
            return false;
        },
        hasValidAnswer() {
            return true;
        },
        hasValidAddress: function() {
            return !!this.content.data.address && !!this.content.data.latitude && !!this.content.data.longitude;
        },
    },
    methods: {
        highlightInvalidState() {
            this.showInvalid = true;
        },
        getDataToPersist() {
            return {
                question_id: this.id,
                answer: '',
                answer_id: null
            };
        },
    }
}
</script>

<style scoped></style>
